let PlayersLock = {
    LOCKING_SET_PLAYERS: 'LOCKING_SET_PLAYERS',
};

export default PlayersLock;
